"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZebraPrinter = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@capacitor/core");
const ZebraPrinter = (0, core_1.registerPlugin)('ZebraPrinter', {
    web: () => Promise.resolve().then(() => require('./web')).then(m => new m.ZebraPrinterWeb()),
});
exports.ZebraPrinter = ZebraPrinter;
tslib_1.__exportStar(require("./definitions"), exports);
//# sourceMappingURL=index.js.map